export const ONBOARDING_STEP_KEY = "onboardingStep";
